import { ApiError } from "@bw/shared/api";

export function settingsUpdateErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (
    error instanceof ApiError &&
    error.status === 503 &&
    error.code === "SETTINGS_UPDATE_FAILED"
  ) {
    return "Settings are temporarily unavailable.";
  }
  return fallback;
}
